module.exports = __webpack_public_path__ + "static/hyperv_1.76ad4ac9.jpg";